module.exports = __webpack_public_path__ + "static/media/active_indicator.96b6dac3.png";